import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { MarketValue } from './market-value.model';

export interface MarketValuesState extends EntityState<MarketValue> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'marketValues', idKey: 'valueDate' })
export class MarketValuesStore extends EntityStore<MarketValuesState> {
    constructor() {
        super({});
    }
    akitaPreAddEntity(marketValue: MarketValue) {
        marketValue = {
            ...marketValue,
            valueDate: new Date(marketValue.valueDate).getTime()
        };
        return marketValue;
    }
}
